/**
 * Stack navigator for the letter-first onboarding flow (onboardingVersion 2).
 *
 * The root navigator decides whether to mount this stack — see
 * pickPostAuthTarget / letterScreenForStep in src/navigation/postAuthRoute.ts.
 */
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import React from 'react';

import { LetterCanvasScreen } from './LetterCanvasScreen';
import { LetterDeliveryScreen } from './LetterDeliveryScreen';
import { LetterHookScreen } from './LetterHookScreen';
import { LetterInterviewScreen } from './LetterInterviewScreen';
import { LetterLevelsScreen } from './LetterLevelsScreen';
import { LetterPaywallScreen } from './LetterPaywallScreen';
import { LetterPeopleScreen } from './LetterPeopleScreen';
import { LetterRecipientScreen } from './LetterRecipientScreen';
import { LetterRecorderScreen } from './LetterRecorderScreen';
import { LetterRecordOfferScreen } from './LetterRecordOfferScreen';
import { LetterReviewScreen } from './LetterReviewScreen';
import { LetterSavedScreen } from './LetterSavedScreen';
import { LettersHomeScreen } from './LettersHomeScreen';
import { LetterTierExplainerScreen } from './LetterTierExplainerScreen';
import { SecurityOptionsScreen } from './SecurityOptionsScreen';

const Stack = createNativeStackNavigator();

export const LetterFirstNavigator: React.FC = () => (
  <Stack.Navigator
    screenOptions={{
      headerShown: false,
      gestureEnabled: false,
      animation: 'slide_from_right',
    }}
  >
    <Stack.Screen name="LetterHook" component={LetterHookScreen} />
    <Stack.Screen name="LetterLevels" component={LetterLevelsScreen} />
    <Stack.Screen name="LetterRecipient" component={LetterRecipientScreen} />
    <Stack.Screen name="LetterCanvas" component={LetterCanvasScreen} />
    <Stack.Screen name="LetterInterview" component={LetterInterviewScreen} />
    <Stack.Screen name="LetterReview" component={LetterReviewScreen} />
    <Stack.Screen name="LetterSaved" component={LetterSavedScreen} />
    <Stack.Screen name="LettersHome" component={LettersHomeScreen} />
    <Stack.Screen name="LetterRecordOffer" component={LetterRecordOfferScreen} />
    <Stack.Screen name="LetterRecorder" component={LetterRecorderScreen} />
    <Stack.Screen name="LetterPaywall" component={LetterPaywallScreen} />
    <Stack.Screen name="LetterDelivery" component={LetterDeliveryScreen} />
    <Stack.Screen name="LetterPeople" component={LetterPeopleScreen} />
    <Stack.Screen name="LetterTierExplainer" component={LetterTierExplainerScreen} />
    <Stack.Screen name="SecurityOptions" component={SecurityOptionsScreen} />
  </Stack.Navigator>
);

export default LetterFirstNavigator;
